import MobileScrollContainer from './MobileScrollContainer';

export default MobileScrollContainer;
